
import { Component, Vue } from 'vue-property-decorator'
@Component({
	data() {
		return {}
	}
})
export default class Home extends Vue {}
